import { useSignal } from '@preact/signals'
import { useCallback, useEffect } from 'preact/hooks'

import type { BoundForEventType } from '@/constants'
import type { Board } from '@/core/Board'
import type { GridCoords } from '@/core/Board/types'
import { game } from '@/core/Game'
import { eventBus } from '@/libs/EventBus'

import { BuildMenu } from './components/BuildMenu'

interface SideBarProps {
  board: Board
  onSignout: () => void
}
export function SideBar({ board, onSignout }: Readonly<SideBarProps>) {
  const boardSelection = useSignal<[start: GridCoords, end: GridCoords] | undefined>()
  const [boardSelectionStart, boardSelectionEnd] = boardSelection.value ?? []

  const onBoardSelectionChange = useCallback((event: WindowEventMap[BoundForEventType.BoardSelectionEnd]) => {
    const previousValue = boardSelection.peek()
    if (previousValue?.[0].id === event.payload?.[0].id && previousValue?.[1].id === event.payload?.[1].id) {
      return
    }

    boardSelection.value = event.payload
  }, [])

  useEffect(() => {
    eventBus.BoardSelectionEnd.subscribe(onBoardSelectionChange)
  }, [onBoardSelectionChange])

  return (
    <>
      {board.hoveredTileCoords.value && board.hoveredTileCoords.value && (
        <div>
          <strong>Highlighted Tile</strong>
          <br />
          {`x: ${board.hoveredTileCoords.value?.x}, y: ${board.hoveredTileCoords.value?.y}`}
        </div>
      )}

      {boardSelectionStart && boardSelectionEnd && (
        <>
          <div>
            <hr />
            <strong>Selected Tiles</strong>
            <br />
            {`x0: ${boardSelectionStart.x}, y0: ${boardSelectionStart.y}, x1: ${boardSelectionEnd.x}, y1: ${boardSelectionEnd.y}`}
          </div>

          <div>
            <hr />
            <BuildMenu gridZone={[boardSelectionStart, boardSelectionEnd]} />
          </div>
        </>
      )}

      {game.error.value !== undefined && (
        <div>
          <hr />
          <strong>City Hall says:</strong>
          <br />
          {game.error.value}
        </div>
      )}

      <button class="signout" onClick={onSignout} type="button">
        Sign out
      </button>
    </>
  )
}
